import { render, staticRenderFns } from "./CheckboxIcon.vue?vue&type=template&id=2e93074a&lang=pug&"
import script from "./CheckboxIcon.vue?vue&type=script&lang=ts&"
export * from "./CheckboxIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CheckboxIcon.vue"
export default component.exports